import { DndBusService } from './../dnd-bus.service';
import { CdkDragEnd } from "@angular/cdk/drag-drop";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { SearchResult } from "@core_n/asp/interfaces";
import { SensorsCorePool } from "@core_n/asp/SensorsCorePool";
import { interval, Observable, of, Subscription } from "rxjs";
import { filter, switchMap, take } from "rxjs/operators";
import { VideoSplitService } from "../video-split/video-split.service";
import { aspMngr } from "./../../asp/AspMngr";
import { ObjectType } from "./../../asp/AspObject";
@Component({
  selector: "app-camera-list",
  templateUrl: "./camera-list.component.html",
  styleUrls: ["./camera-list.component.scss"],
})
export class CameraListComponent implements OnInit, OnDestroy {
  @Input() query$!: Observable<string>;
  cameras: SearchResult[] = [];
  querySubscription: Subscription;
  public connectedDropLists: string[] = this._splitService.connectedDropLists;

  constructor(
      private _splitService: VideoSplitService,
      private dndBusService: DndBusService
    ) {}

  ngOnInit(): void {
    this.querySubscription = this.query$.subscribe((str) => {
      this.fetchCameras(str);
    });

    this.initCameras().subscribe(() => {
      this.fetchCameras();
    });
  }


  public onDragStart(camera: SearchResult){
      this.dndBusService.dragStart({ type: 'camera', data: camera });
  }
  public dragEnded(event: CdkDragEnd){
    //this.dnd.dragEnd();
    //event.source.reset();
  }

  private fetchCameras(str: string = "") {
    this.cameras = (aspMngr.getObjectsPool(
      ObjectType.Sensor
    ) as SensorsCorePool).searchObjects(str).filter(result => result.obj["isVideo"] == true);
    return this.cameras?.length ?? 0;
  }

  private initCameras() {
    return interval(2000).pipe(
      switchMap(() => {
        return of(this.fetchCameras());
      }),
      filter((length) => length != 0),
      take(1)
    );
  }

  public trackById(_: number, cam: SearchResult){
      return cam.obj.id;
  }



  ngOnDestroy() {
    this.querySubscription.unsubscribe();
  }
}
